import auth from './auth';
import fileUpload from './fileUpload';
import preview from './preview';

const api = {
   auth,
   preview,
   fileUpload,
};

export default api;
